// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { App } from "@capacitor/app";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Browser } from "@capacitor/browser";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Clipboard } from "@capacitor/clipboard";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Device } from "@capacitor/device";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Geolocation } from "@capacitor/geolocation";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Haptics, ImpactStyle } from "@capacitor/haptics";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Keyboard } from "@capacitor/keyboard";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Network } from "@capacitor/network";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Preferences } from "@capacitor/preferences";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { PushNotifications } from "@capacitor/push-notifications";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { ScreenOrientation } from "@capacitor/screen-orientation";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Share } from "@capacitor/share";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { StatusBar, StatusBarStyle } from "@capacitor/status-bar";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { InAppReview } from "@capacitor-community/in-app-review";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { NativeMarket } from "@capacitor-community/native-market";
import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Diagnostic } from "@ionic-native/diagnostic";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  useTheme,
} from "@mui/material";
import { isAndroidPlatform, isIosPlatform, useToast } from "@src/appV2/lib";
import { openNativeSettings } from "@src/appV2/lib/NativeSettings/native-settings";
import { startNFCScan } from "@src/appV2/Nfc/utils/nfcReader";
import { NfcReaderError, NfcReaderErrorType } from "@src/appV2/Nfc/utils/nfcReaderError";
import { LockScreenOrientationVariant } from "@src/appV2/ScreenOrientation";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { changeUser } from "appboy-cordova-sdk/www/AppboyPlugin";
import { noop } from "lodash";
import { type ReactElement, useState } from "react";

import { useNativeDatePicker } from "../../lib/DatePicker/useNativeDatePicker";
import { useNativeTimePicker } from "../../lib/DatePicker/useNativeTimePicker";
import { LiveActivityDebugger } from "./LiveActivityDebugger";

enum TestResult {
  SUCCESS = "passed",
  FAILURE = "failed",
  PENDING = "pending",
}

interface Scenario {
  key: string;
  execute: () => Promise<TestResult>;
  displayName: string;
  status: TestResult;
}

async function rotateScreenToLandscape() {
  try {
    await ScreenOrientation.lock({
      orientation: LockScreenOrientationVariant.LANDSCAPE_PRIMARY,
    });
  } catch {
    return TestResult.FAILURE;
  }

  return TestResult.SUCCESS;
}

async function rotateScreenToPortrait() {
  try {
    await ScreenOrientation.lock({
      orientation: LockScreenOrientationVariant.PORTRAIT_PRIMARY,
    });
  } catch {
    return TestResult.FAILURE;
  }

  return TestResult.SUCCESS;
}

async function getDeviceLocation() {
  try {
    JSON.stringify(await Geolocation.getCurrentPosition());
    return TestResult.SUCCESS;
  } catch {
    return TestResult.FAILURE;
  }
}

async function testDeviceNetwork() {
  try {
    const networkHandler = await Network.addListener("networkStatusChange", noop);
    await networkHandler.remove();
    const status = await Network.getStatus();
    if (isDefined(status.connected) && isDefined(status.connectionType)) {
      return TestResult.SUCCESS;
    }

    return TestResult.FAILURE;
  } catch {
    return TestResult.FAILURE;
  }
}

async function testMarketPlugin() {
  try {
    if (isIosPlatform()) {
      await NativeMarket.openStoreListing({ appId: "id1472962791" });
    }

    if (isAndroidPlatform()) {
      await NativeMarket.openStoreListing({ appId: "health.clipboard.worker" });
    }

    return TestResult.SUCCESS;
  } catch {
    return TestResult.FAILURE;
  }
}

async function testPushNotifications(userId: string) {
  try {
    await PushNotifications.requestPermissions();
    await PushNotifications.register();

    changeUser(userId);
    return TestResult.SUCCESS;
  } catch {
    return TestResult.FAILURE;
  }
}

async function testCapacitorShare() {
  try {
    await Share.share({
      title: "Test title",
      text: "Test text",
      url: "https://test-share.com",
    });
  } catch {
    return TestResult.FAILURE;
  }

  return TestResult.SUCCESS;
}

async function testCapacitorClipboard() {
  try {
    await Clipboard.write({
      string: "Some text for clipboard",
    });
  } catch {
    return TestResult.FAILURE;
  }

  return TestResult.SUCCESS;
}

async function testCapacitorPreference() {
  try {
    const preferenceKey = "test-preference-key";
    const expectedValue = "test-preference-value";
    await Preferences.set({
      key: preferenceKey,
      value: expectedValue,
    });

    const { value: actualValue } = await Preferences.get({ key: preferenceKey });

    if (actualValue !== expectedValue) {
      throw new Error("Capacitor Preference set/get test has failed");
    }
  } catch {
    return TestResult.FAILURE;
  }

  return TestResult.SUCCESS;
}

async function testBrowserLink() {
  try {
    await Browser.open({ url: "https://clipboardhealth.com" });
  } catch {
    return TestResult.FAILURE;
  }

  return TestResult.SUCCESS;
}

async function testNfcPlugin() {
  let nfcReader;
  try {
    nfcReader = startNFCScan();
  } catch {
    return TestResult.FAILURE;
  }

  let nfcReadString: string;
  try {
    nfcReadString = nfcReader.readOne(500);
  } catch (error: unknown) {
    // Test passes if a timeout is reached (NFC scanner starts then is stopped)
    if (error instanceof NfcReaderError && error.type === NfcReaderErrorType.SCAN_TIMEOUT) {
      return TestResult.SUCCESS;
    }
  }

  // Test also passes if a tag is actually read in this time
  if (nfcReadString) {
    return TestResult.SUCCESS;
  }

  return TestResult.FAILURE;
}

async function testNativeTimePicker(openTimePicker: () => Promise<string | undefined>) {
  try {
    await openTimePicker();
    // If we get here without an exception, the plugin worked
    // (regardless of whether user selected time or cancelled)
    return TestResult.SUCCESS;
  } catch {
    return TestResult.FAILURE;
  }
}

async function testNativeDatePicker(openDatePicker: () => Promise<string | undefined>) {
  try {
    await openDatePicker();
    // If we get here without an exception, the plugin worked
    // (regardless of whether user selected date or cancelled)
    return TestResult.SUCCESS;
  } catch {
    return TestResult.FAILURE;
  }
}

export function NativePlugins(): ReactElement {
  const worker = useDefinedWorker();
  const { showInfoToast } = useToast();
  const timePicker = useNativeTimePicker({
    confirmText: "Done",
    cancelText: "Close",
    onTimeSelected: (timeValue) => {
      showInfoToast(`Time confirmed: ${timeValue}`);
    },
    onCancel: () => {
      showInfoToast("Time picker cancelled");
    },
  });
  const datePicker = useNativeDatePicker({
    confirmText: "Done",
    cancelText: "Close",
    onDateSelected: (dateValue) => {
      showInfoToast(`Date confirmed: ${dateValue}`);
    },
    onCancel: () => {
      showInfoToast("Date picker cancelled");
    },
  });
  const initialScenarios: Scenario[] = [
    {
      key: "Rotate screen to landscape",
      execute: rotateScreenToLandscape,
      displayName: "Rotate screen to landscape",
      status: TestResult.PENDING,
    },
    {
      key: "Rotate screen to portrait",
      execute: rotateScreenToPortrait,
      displayName: "Rotate screen to portrait",
      status: TestResult.PENDING,
    },
    {
      key: "Test Push Notifications",
      execute: async () => await testPushNotifications(worker.userId),
      displayName: "Test Push Notifications",
      status: TestResult.PENDING,
    },
    {
      key: "Get device location",
      execute: getDeviceLocation,
      displayName: "Get device location",
      status: TestResult.PENDING,
    },
    {
      key: "Test Capacitor Share",
      execute: testCapacitorShare,
      displayName: "Test Capacitor Share",
      status: TestResult.PENDING,
    },
    {
      key: "Test Capacitor Clipboard",
      execute: testCapacitorClipboard,
      displayName: "Test Capacitor Clipboard",
      status: TestResult.PENDING,
    },
    {
      key: "Test Capacitor Preference",
      execute: testCapacitorPreference,
      displayName: "Test Capacitor Preference",
      status: TestResult.PENDING,
    },
    {
      key: "Test Browser Link",
      execute: testBrowserLink,
      displayName: "Test Browser Link",
      status: TestResult.PENDING,
    },
    {
      key: "Test Network plugin",
      execute: testDeviceNetwork,
      displayName: "Test Network plugin",
      status: TestResult.PENDING,
    },
    {
      key: "Test Market plugin",
      execute: testMarketPlugin,
      displayName: "Test Market plugin",
      status: TestResult.PENDING,
    },
    {
      key: "Test NFC plugin",
      execute: testNfcPlugin,
      displayName: "Test NFC plugin",
      status: TestResult.PENDING,
    },
    {
      key: "Test Native Time Picker",
      execute: async () => await testNativeTimePicker(timePicker.openTimePicker),
      displayName: "Test Native Time Picker",
      status: TestResult.PENDING,
    },
    {
      key: "Test Native Date Picker",
      execute: async () => await testNativeDatePicker(datePicker.openDatePicker),
      displayName: "Test Native Date Picker",
      status: TestResult.PENDING,
    },
    {
      key: "Show Keyboard (Only works on Android)",
      execute: async () => {
        try {
          if (isAndroidPlatform()) {
            // Only works on Android
            try {
              await Keyboard.show();
              return TestResult.SUCCESS;
            } catch {
              return TestResult.FAILURE;
            }
          }

          return TestResult.SUCCESS;
        } catch {
          return TestResult.FAILURE;
        }
      },
      displayName: "Show Keyboard (Only works on Android)",
      status: TestResult.PENDING,
    },
    {
      key: "Device Info",
      execute: async () => {
        try {
          const deviceInfo = await Device.getInfo();
          showInfoToast(JSON.stringify(deviceInfo));
          return TestResult.SUCCESS;
        } catch {
          return TestResult.FAILURE;
        }
      },
      displayName: "Device Info Test",
      status: TestResult.PENDING,
    },
    {
      key: "App Info",
      execute: async () => {
        try {
          const appInfo = await App.getInfo();
          showInfoToast(JSON.stringify(appInfo));
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "App Info Test",
      status: TestResult.PENDING,
    },
    {
      key: "App State",
      displayName: "App State Listener Test",
      execute: async () => {
        try {
          const appState = await App.getState();
          showInfoToast(JSON.stringify(appState));
          await App.addListener("appStateChange", (state) => {
            showInfoToast(`appStateChange running: ${JSON.stringify(state)}`);
          });
          await App.addListener("resume", (state) => {
            showInfoToast(`resume running: ${JSON.stringify(state)}`);
          });
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      status: TestResult.PENDING,
    },
    {
      key: "Haptics",
      execute: async () => {
        try {
          await Haptics.impact({ style: ImpactStyle.Medium });
          return TestResult.SUCCESS;
        } catch {
          return TestResult.FAILURE;
        }
      },
      displayName: "Haptics Impact Test",
      status: TestResult.PENDING,
    },
    {
      key: "Haptics Selection",
      execute: async () => {
        try {
          await Haptics.selectionStart();
          await new Promise((resolve) => {
            setTimeout(resolve, 500);
          });
          await Haptics.selectionEnd();
          return TestResult.SUCCESS;
        } catch {
          return TestResult.FAILURE;
        }
      },
      displayName: "Haptics Selection Test",
      status: TestResult.PENDING,
    },
    {
      key: "Status Bar Hide",
      execute: async () => {
        try {
          await StatusBar.hide();
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Status Bar Hide Test",
      status: TestResult.PENDING,
    },
    {
      key: "Status Bar Show",
      execute: async () => {
        try {
          await StatusBar.show();
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Status Bar Show Test",
      status: TestResult.PENDING,
    },
    {
      key: "Status Bar Style Light",
      execute: async () => {
        try {
          await StatusBar.setStyle({ style: StatusBarStyle.Light });
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Status Bar Style Light Test",
      status: TestResult.PENDING,
    },
    {
      key: "Status Bar Style Dark",
      execute: async () => {
        try {
          await StatusBar.setStyle({ style: StatusBarStyle.Dark });
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Status Bar Style Dark Test",
      status: TestResult.PENDING,
    },
    {
      key: "In App Rating Prompt",
      execute: async () => {
        try {
          await InAppReview.requestReview();
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "In App Rating Prompt Test",
      status: TestResult.PENDING,
    },
    {
      key: "Open Native Settings (settings)",
      execute: async () => {
        try {
          await openNativeSettings({ option: "settings" });
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Open Native Settings (settings)",
      status: TestResult.PENDING,
    },
    {
      key: "Open Native Settings (application_details)",
      execute: async () => {
        try {
          await openNativeSettings({ option: "application_details" });
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Open Native Settings (application_details)",
      status: TestResult.PENDING,
    },
    {
      key: "Open Native Settings (location)",
      execute: async () => {
        try {
          await openNativeSettings({ option: "location" });
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Open Native Settings (location)",
      status: TestResult.PENDING,
    },
    {
      key: "Get Microphone Authorization Status",
      execute: async () => {
        try {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const status = await Diagnostic.getMicrophoneAuthorizationStatus();
          showInfoToast(JSON.stringify(status));
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Get Microphone Authorization Status",
      status: TestResult.PENDING,
    },
    {
      key: "Get Camera Authorization Status",
      execute: async () => {
        try {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const status = await Diagnostic.getCameraAuthorizationStatus(false);
          showInfoToast(JSON.stringify(status));
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Get Camera Authorization Status",
      status: TestResult.PENDING,
    },
    {
      key: "Get Location Authorization Status",
      execute: async () => {
        try {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const status = await Diagnostic.getLocationAuthorizationStatus();
          showInfoToast(JSON.stringify(status));
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Get Location Authorization Status",
      status: TestResult.PENDING,
    },
    {
      key: "Get Location Accuracy Authorization",
      execute: async () => {
        try {
          const status = await Diagnostic.getLocationAccuracyAuthorization();
          showInfoToast(JSON.stringify(status));
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Get Location Accuracy Authorization",
      status: TestResult.PENDING,
    },
    {
      key: "Request Microphone Authorization",
      execute: async () => {
        try {
          await Diagnostic.requestMicrophoneAuthorization();
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Request Microphone Authorization",
      status: TestResult.PENDING,
    },
    {
      key: "Request Camera Authorization",
      execute: async () => {
        try {
          await Diagnostic.requestCameraAuthorization(true);
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Request Camera Authorization",
      status: TestResult.PENDING,
    },
    {
      key: "Request Location Authorization",
      execute: async () => {
        try {
          await Diagnostic.requestLocationAuthorization(true);
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Request Location Authorization",
      status: TestResult.PENDING,
    },
    {
      key: "Is NFC Present using Diagnostic",
      execute: async () => {
        try {
          const isNfcPresent = await Diagnostic.isNFCPresent();
          showInfoToast(JSON.stringify(isNfcPresent));
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Show broken Diagnostic.isNFCPresent()",
      status: TestResult.PENDING,
    },
    {
      key: "Is NFC Present using NFC plugin (getNfcStatus)",
      execute: async () => {
        try {
          const nfcReader = startNFCScan();
          const status = await nfcReader.getNfcStatus();
          showInfoToast(JSON.stringify(status));
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Is NFC Present using NFC plugin (getNfcStatus)",
      status: TestResult.PENDING,
    },
    {
      key: "Is Location Enabled using Diagnostic",
      execute: async () => {
        try {
          const isLocationEnabled = await Diagnostic.isLocationEnabled();
          showInfoToast(JSON.stringify(isLocationEnabled));
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Is Location Enabled using Diagnostic",
      status: TestResult.PENDING,
    },
    {
      key: "Is Location Available using Diagnostic",
      execute: async () => {
        try {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const isLocationAvailable = await Diagnostic.isLocationAvailable();
          showInfoToast(JSON.stringify(isLocationAvailable));
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Is Location Available using Diagnostic",
      status: TestResult.PENDING,
    },
    {
      key: "Switch to Settings using Diagnostic",
      execute: async () => {
        try {
          await Diagnostic.switchToSettings();
        } catch {
          return TestResult.FAILURE;
        }

        return TestResult.SUCCESS;
      },
      displayName: "Switch to Settings using Diagnostic",
      status: TestResult.PENDING,
    },
  ];

  const [scenarios, setScenarios] = useState<Scenario[]>(initialScenarios);

  const theme = useTheme();

  function getStatusColor(status: TestResult): string {
    switch (status) {
      case TestResult.PENDING: {
        return theme.palette.text.primary;
      }

      case TestResult.SUCCESS: {
        return theme.palette.success.main;
      }

      case TestResult.FAILURE: {
        return theme.palette.error.main;
      }

      default: {
        return theme.palette.text.primary;
      }
    }
  }

  return (
    <Box>
      <Table>
        <TableBody>
          {scenarios.map((scenario) => (
            <TableRow key={`scenario-${scenario.key}`}>
              <TableCell>
                <Button
                  fullWidth
                  size="small"
                  variant="contained"
                  sx={{ fontSize: "10px", whiteSpace: "normal" }}
                  onClick={async () => {
                    const result = await scenario.execute();
                    setScenarios((previousScenarios) => {
                      return previousScenarios.map((s) =>
                        s.key === scenario.key ? { ...s, status: result } : s
                      );
                    });
                  }}
                >
                  Run
                </Button>
              </TableCell>
              <TableCell>
                <Text color={getStatusColor(scenario.status)}>
                  {scenario.displayName}:{scenario.status}
                </Text>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Button
        fullWidth
        sx={{ fontSize: "10px" }}
        variant="outlined"
        onClick={() => {
          setScenarios(initialScenarios);
        }}
      >
        Reset Scenarios
      </Button>

      <Box sx={{ mt: 4, pt: 2, borderTop: "1px solid #e0e0e0" }}>
        <TextField
          label="Keyboard hide test: auto hide keyboard after 2 seconds"
          onFocus={async () => {
            setTimeout(async () => {
              await Keyboard.hide();
            }, 2000);
          }}
        />
      </Box>

      {/* Live Activities Debugging Section */}
      <Box sx={{ mt: 4, pt: 2, borderTop: "1px solid #e0e0e0" }}>
        <LiveActivityDebugger />
      </Box>
    </Box>
  );
}
